// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"b49e0673","186":"27220506","272":"c6af81df","372":"fe97004e","377":"772f3b13","738":"3712cd7f","841":"b63e5d4e","851":"12d62a12","856":"c85e3212"}[chunkId] + ".chunk.js";
};